import React from "react";
import SelectableOptionGrid from "./SelectableOptionGrid";

export const SUPPORTED_LANGUAGE_CODES = ["en", "fr", "es", "ht", "pt"];

export const supportedLanguageOptions = (infoSource) => {
  const labels = infoSource?.laguangeElakay?.("supportedLanguages", infoSource.languageAPI) || {};
  return SUPPORTED_LANGUAGE_CODES.map((code) => ({ value: code, label: labels[code] || code.toUpperCase() }));
};

export const languageLabels = (codes, infoSource) => {
  const labelByCode = new Map(supportedLanguageOptions(infoSource).map((option) => [option.value, option.label]));
  return (codes || []).map((code) => ({ code, label: labelByCode.get(code) || code.toUpperCase() }));
};

const LanguageSelector = ({ infoSource, selectedCodes = [], onChange, disabled = false, title, help }) => {
  const toggle = (code) => onChange(
    selectedCodes.includes(code)
      ? selectedCodes.filter((selected) => selected !== code)
      : [...selectedCodes, code]
  );

  return (
    <section className="third-category-selector language-selector">
      <div className="third-category-header">
        <div>
          <h4>{title}</h4>
          {help && <p>{help}</p>}
        </div>
        <strong>{selectedCodes.length} / {SUPPORTED_LANGUAGE_CODES.length}</strong>
      </div>
      <SelectableOptionGrid
        options={supportedLanguageOptions(infoSource)}
        selectedValues={selectedCodes}
        onToggle={toggle}
        disabled={disabled}
      />
    </section>
  );
};

export default LanguageSelector;
